import { useCallback } from 'react';
import { mergeRefs } from '../utils';
export var useCombinedRefs = function useCombinedRefs(ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9) {
  return useCallback(mergeRefs(ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9), [ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9]);
};